import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'
import WorldMap from './WorldMap'
import Card from './Card'
import Graph from './Graph'
import { GraphSalesData, HighLightsData, MapFilterData, salesFilterData } from 'pages/sales-forecast/salesForecastTypes'
import { ToggleViewState } from 'pages/forecast/forecastTypes'


export interface DefaultGraphProps {
  graphData: GraphSalesData | undefined
  salesMapData: any
  downloadCsv: boolean
  setDownloadCsv: Dispatch<SetStateAction<boolean>>;
  currentUIView: ToggleViewState
  salesFilterData: salesFilterData
  mapFilterData: MapFilterData
  cardRef: React.MutableRefObject<any>
  setToggleView: Dispatch<SetStateAction<ToggleViewState>>;
  fetchSalesData: (filterData: salesFilterData) => Promise<void>;
  setSalesFilterData: Dispatch<SetStateAction<salesFilterData>>;
  setMapFilterData: Dispatch<SetStateAction<MapFilterData>>
}

// interface TableRow {
//   col1: string | undefined
//   col2: string | undefined
//   col3: string | undefined
// }

// // Define the type for columns
// interface TableColumn {
//   title: string;
//   dataKey: keyof TableRow; // Restrict dataKey to valid keys of TableRow
// }

const DefaultGraph: React.FC<DefaultGraphProps> = ({graphData, salesFilterData, salesMapData, downloadCsv, setDownloadCsv, 
  mapFilterData, currentUIView, cardRef, setToggleView, fetchSalesData , setSalesFilterData, setMapFilterData

}) => {

  // const cardRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef(); 


  return (
    <div>
        
        <WorldMap salesMapData={salesMapData} mapFilterData={mapFilterData} mapRef={mapRef} setToggleView={setToggleView} salesFilterData={salesFilterData}
        fetchSalesData={fetchSalesData} setSalesFilterData={setSalesFilterData} setMapFilterData={setMapFilterData}/>
        <Graph graphData={graphData} downloadCsv={downloadCsv} setDownloadCsv={setDownloadCsv} currentUIView={currentUIView}
        salesFilterData={salesFilterData} cardRef={cardRef} mapRef={mapRef}/>
      
    </div>
  )
}

export default DefaultGraph



